"use client";

import { ScrollReveal } from "@/components/ui/scroll-reveal";

export function Problems() {
  return (
    <section className="py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <ScrollReveal>
          <p className="text-sm font-medium text-red-400 text-center mb-4">
            Апрель 2026
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight text-center max-w-3xl mx-auto leading-tight">
            Комиссии выросли до 50%.
            <br />
            <span className="text-white/50">Куда уходит ваша выручка?</span>
          </h2>
          <p className="text-base text-white/50 text-center mt-6 max-w-2xl mx-auto">
            При операционных расходах 45-55% от оборота каждый артикул может быть
            убыточным. Проблема в том, что вы не видите это по каждому товару отдельно.
          </p>
        </ScrollReveal>

        {/* Визуализация: один товар, разные размеры, разная прибыль */}
        <ScrollReveal delay={0.2}>
          <div className="mt-16 rounded-2xl border border-white/[0.08] bg-white/[0.02] overflow-hidden">
            <div className="px-6 py-4 border-b border-white/[0.06] flex items-center justify-between">
              <span className="text-sm text-white/60">Футболка оверсайз — один артикул, три размера, три разных результата</span>
              <span className="text-xs text-white/30 hidden sm:block">Данные из MPUNIT</span>
            </div>

            <div className="divide-y divide-white/[0.04]">
              {/* Прибыльный размер */}
              <div className="grid grid-cols-[1fr_auto] md:grid-cols-[2fr_1fr_1fr_1fr] gap-4 px-6 py-5 items-center">
                <div>
                  <div className="text-sm font-medium text-white">Размер L</div>
                  <div className="text-xs text-white/40 mt-0.5">420 продаж · WB</div>
                </div>
                <div className="hidden md:block text-right">
                  <div className="text-xs text-white/40">Выручка</div>
                  <div className="text-sm text-white">₽588,000</div>
                </div>
                <div className="hidden md:block text-right">
                  <div className="text-xs text-white/40">Все расходы</div>
                  <div className="text-sm text-white/70">₽232,260</div>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-bold text-emerald-400">+₽847</div>
                  <div className="text-xs text-emerald-400/60">на единицу</div>
                </div>
              </div>

              {/* Убыточный размер — красный фон */}
              <div className="grid grid-cols-[1fr_auto] md:grid-cols-[2fr_1fr_1fr_1fr] gap-4 px-6 py-5 items-center bg-red-500/[0.04] border-l-2 border-red-500/40">
                <div>
                  <div className="text-sm font-medium text-white">Размер XS</div>
                  <div className="text-xs text-white/40 mt-0.5">180 продаж · WB</div>
                </div>
                <div className="hidden md:block text-right">
                  <div className="text-xs text-white/40">Выручка</div>
                  <div className="text-sm text-white">₽252,000</div>
                </div>
                <div className="hidden md:block text-right">
                  <div className="text-xs text-white/40">Все расходы</div>
                  <div className="text-sm text-red-300">₽308,160</div>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-bold text-red-400">−₽312</div>
                  <div className="text-xs text-red-400/60">на единицу</div>
                </div>
              </div>

              {/* Нормальный размер */}
              <div className="grid grid-cols-[1fr_auto] md:grid-cols-[2fr_1fr_1fr_1fr] gap-4 px-6 py-5 items-center">
                <div>
                  <div className="text-sm font-medium text-white">Размер M</div>
                  <div className="text-xs text-white/40 mt-0.5">310 продаж · WB</div>
                </div>
                <div className="hidden md:block text-right">
                  <div className="text-xs text-white/40">Выручка</div>
                  <div className="text-sm text-white">₽434,000</div>
                </div>
                <div className="hidden md:block text-right">
                  <div className="text-xs text-white/40">Все расходы</div>
                  <div className="text-sm text-white/70">₽285,230</div>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-bold text-emerald-400">+₽480</div>
                  <div className="text-xs text-emerald-400/60">на единицу</div>
                </div>
              </div>
            </div>

            <div className="px-6 py-4 border-t border-white/[0.06] bg-white/[0.02]">
              <p className="text-sm text-white/50">
                <span className="text-red-400 font-medium">Размер XS теряет ₽56,160 в месяц</span> — и тянет
                весь артикул вниз. Без разбивки по размерам вы этого не увидите.
              </p>
            </div>
          </div>
        </ScrollReveal>

        {/* Три боли в цифрах */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-10">
          <ScrollReveal delay={0.3}>
            <div className="rounded-xl border border-white/[0.08] bg-white/[0.02] p-6">
              <div className="text-3xl font-bold text-red-400">50-70%</div>
              <p className="text-sm text-white/50 mt-2">
                Комиссия Ozon в некоторых категориях. Полгода назад было 30%.
              </p>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={0.4}>
            <div className="rounded-xl border border-white/[0.08] bg-white/[0.02] p-6">
              <div className="text-3xl font-bold text-amber-400">15-25%</div>
              <p className="text-sm text-white/50 mt-2">
                Доля рекламных расходов от выручки. Было 5-8%. Реклама съедает маржу.
              </p>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={0.5}>
            <div className="rounded-xl border border-white/[0.08] bg-white/[0.02] p-6">
              <div className="text-3xl font-bold text-white">30 дней</div>
              <p className="text-sm text-white/50 mt-2">
                Задержка выплат на WB с марта 2026. Было 14 дней. Кэш заморожен.
              </p>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
